import { useState } from "react";
import { Box, Typography, Checkbox, Button, Link } from "@mui/material";
import { PP_URL, TOS_URL } from "config";

const UserAgreement = ({ onAccept }) => {
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        User Agreement
      </Typography>
      <Typography variant="body1" gutterBottom>
        To use XyloPlan, please review and accept our Terms of Service and
        Privacy Policy.
      </Typography>
      <Typography variant="body2" fontStyle="italic" gutterBottom>
        This software builds on the MTT framework of Mark Finney and the
        Missoula Fire Sciences Lab.
      </Typography>
      <Box sx={{ my: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <label>
            <Checkbox
              sx={{ paddingLeft: 0 }}
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
            <Typography variant="body2" component="span">
              I have read and agree to the{" "}
              <Link href={TOS_URL} target="_blank">
                Terms of Service
              </Link>
            </Typography>
          </label>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <label>
            <Checkbox
              sx={{ paddingLeft: 0 }}
              checked={privacyChecked}
              onChange={(e) => setPrivacyChecked(e.target.checked)}
            />
            <Typography variant="body2" component="span">
              I have read and agree to the{" "}
              <Link href={PP_URL} target="_blank">
                Privacy Policy
              </Link>
            </Typography>
          </label>
        </Box>
      </Box>
      <Button
        variant="contained"
        size="large"
        fullWidth
        disabled={!termsChecked || !privacyChecked}
        onClick={onAccept}
      >
        Enter Application
      </Button>
    </Box>
  );
};

export default UserAgreement;
